(function(module) {
    'use strict';

    const reorder = (arr, order) =>
        _.sortBy(arr, (file) =>
            order.includes(file.id) ? order.indexOf(file.id) : arr.length,
        );

    function ModalCtrl($scope, $mdDialog, $state) {
        // Track selected files without modifying them
        this.selectedFiles = this.selectedFilesIds.reduce((acc, i) => {
            acc[i] = true;
            return acc;
        }, {});

        this.cancel = () => {
            $mdDialog.hide();
        };

        this.confirm = () => {
            const newSelection = this.files.filter(file => this.selectedFiles[file.id]);
            const ordered = reorder(newSelection, this.selectedFilesIds);
            this.selectFiles(ordered);
            this.cancel();
        };

        this.isChecked = ({ id }) => this.selectedFiles[id];
        this.toggleFileSelected = ({ id }) => {
            this.selectedFiles = this.selectedFiles[id] ? {} : { [id]: true };
        };
        this.goToUploadFiles = () => {
            $state.go('root.files.add');
            this.cancel();
        };
    }

    module.config(['formlyConfigProvider', (formlyConfigProvider, $mdDialog, Store) => {
        formlyConfigProvider.setType({
            name: 'formlySinglePicker',
            template: `
                <div class="formly-single-picker" >
                    <md-content ng-if="loading">
                        <div class="formly-picker__loading">
                            <h2 translate="FILES.WHEN_LOADING"></h2>
                        </div>
                    </md-content>
                    <md-content class="files-wrapper playlist" flex="100" ng-if="selectedFiles.length && !loading">
                        <div class="app-tile file" ng-repeat="file in selectedFiles"">
                            <md-card>
                                <div class="app-tile-image">
                                    <div class="app-image-container" class="preview" ng-style="{backgroundImage: 'url(' + (file.fileTypeHeader === 'svg' ? file.original : file.thumbnail) + ')'}"/>
                                </div>
                            </md-card>
                            <md-button class="delete-button md-warn" ng-click="deleteItem($index)">
                                <i class="fa fa-times"></i>
                            </md-button>
                        </div>
                    </md-content>

                    <md-button ng-if="!loading" class="custom-long-btn formly-picker-btn md-normal" ng-click="pickFiles()">
                        <i class="fa fa-hand-pointer-o active "></i>
                        <span ng-show="!files.length">Pick your image</span>
                    </md-button>
                </div>
            `,

            controller: ['$scope', '$mdDialog', 'Store', '$http', 'envService', ($scope, $mdDialog, Store, $http, envService) => {
                const originalKey = $scope.options.key;
                if (originalKey.includes('.')) {
                    const [namespace, key] = originalKey.split('.');
                    $scope.namespacedModel = $scope.model[namespace];
                    $scope.key = key;
                } else {
                    $scope.namespacedModel = $scope.model;
                    $scope.key = originalKey;
                }

                $scope.allFiles = [];
                $scope.selectedFiles = [];

                const account = Store.getCurrentAccount();
                const subAccountId = Store.getCurrentSubAccountId();
                const params = {};
                if (subAccountId) _.set(params, 'subAccountId', subAccountId);
                const request = {
                    method: 'GET',
                    url: `${envService.read('SLS_URI')}/files/list/${account.id}`,
                    params,
                };

                $http(request)
                    .then(({ data }) => {
                        const FILES = data
                            .filter(file => file.contentType.startsWith('image'))
                            .map(file => {
                                if (file.contentType === 'image/svg+xml') {
                                    file.fileTypeHeader = 'svg';
                                } else if (file.contentType.startsWith('image')) {
                                    file.fileTypeHeader = 'image';
                                } else {
                                    file.fileTypeHeader = '';
                                }
                                return file;
                            });
                        $scope.allFiles = Store.setMultiModelData('files', FILES);
                    })
                    .catch((error) => {
                        console.error(error);
                        Raven.captureException(error);
                    });

                $scope.deleteItem = (index) => {
                    $scope.namespacedModel[$scope.key] = null;
                    $scope.form.$setDirty();
                    $scope.form.$setDirty();
                };

                $scope.select = function(files) {
                    $scope.namespacedModel[$scope.key] = _.get(files, '[0].id', null);
                    $scope.form.$setDirty();
                };

                const updateModel = _.debounce(newValue => {
                    $scope.namespacedModel[$scope.key] = _.get(newValue, '[0].id', null);
                }, 100);

                $scope.$watch('allFiles', () => {
                    const id = $scope.namespacedModel[$scope.key];
                    const selectedFile = $scope.allFiles.find(file => file.id === id);
                    $scope.selectedFiles = selectedFile ? [selectedFile] : [];
                });

                $scope.$watchGroup([`namespacedModel.${$scope.key}`, 'allFiles'], () => {
                    const id = $scope.namespacedModel[$scope.key];
                    const selectedFile = $scope.allFiles.find(file => file.id === id);
                    if (selectedFile) {
                        $scope.selectedFiles = [selectedFile];
                    } else {
                        $scope.selectedFiles = [];
                    }
                });

                $scope.pickFiles = () => {
                    $mdDialog.show({
                        locals: {
                            title: 'Select files from the list below',
                            cancelText: 'Cancel',
                            files: $scope.allFiles,
                            selectedFilesIds:  $scope.selectedFiles.map(file => file.id),
                            selectFiles: $scope.select,
                        },
                        controller: ModalCtrl,
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/file-picker-dialog/file-picker-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });
                };
            }],
        });
    }]);
})(angular.module('rocket.components'));
